export default __webpack_public_path__ + "static/media/all-logos.aa9cafc4.png";